require('./accountDebitAnnulationSuccess.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ helpers
const { FormattedText } = require('core/i18n').i18n;
// @ utilities
const receiptNumberHelper = require('utilities/receiptNumberHelper');
// @ components
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

class AccountDebitAnnulationSuccess extends React.Component {
    buildSuccessMessage() {
        const { receiptNumber, issuingCompanyId} = this.props;
        const injectedStrings = [
            receiptNumberHelper(receiptNumber),
            issuingCompanyId
        ];
        return (
            <div className="account-debits-annulation-success__message">
                <FormattedText
                    value="annulationSuccessful-successMessage"
                    injectedStrings={injectedStrings}
                />
            </div>
        );
    }

    render() {
        const { accountId } = this.props;
        const title = <FormattedText value="annulationSuccessful-title" />;
        const debitsLink = `/myprofile/accounts/${accountId}/debits`;
        const successMessage = this.buildSuccessMessage();
        const mainButton = {
            url: debitsLink,
            label: <FormattedText value="annulationSuccessful-backToDebits" />
        };
        return (
            <WizardSuccess successMessage={title} mainButton={mainButton}>
                <div>
                    <div className="account-debits-annulation-success__message-container">
                        {successMessage}
                    </div>
                </div>
            </WizardSuccess>
        );
    }
}

AccountDebitAnnulationSuccess.propTypes = {
    accountId: PropTypes.string.isRequired,
    receiptNumber: PropTypes.string.isRequired,
    issuingCompanyId: PropTypes.string.isRequired,
    receiptStatus: PropTypes.string
};

module.exports = AccountDebitAnnulationSuccess;